import React from 'react';

import ResolveActionPendingDialog from '../../components/visit/ResolveActionPendingDialog';

/**
 * TaskResolutionWidget — resolves an open action-pending overlay on a
 * visit. MVP wraps the existing `ResolveActionPendingDialog` (the
 * canonical resolve form) so the SDK call works end-to-end. Folding the
 * three sibling dialogs — ActionPendingDialog (set / forward),
 * ReferralResolveDialog (referral-specific resolve), and
 * CollectReferralPaymentDialog (collect-then-resolve) — into this
 * single widget is a follow-up refactor; for MVP they remain available
 * via their own call sites.
 *
 * Context:
 *   visitId — required
 *   prefill?.visit — the full visit row needed by ResolveActionPendingDialog
 *                     (it reads action_pending_intent etc. off the visit
 *                     object). Callers pass the visit row through prefill
 *                     to avoid a redundant fetch.
 *
 * Side channel: dispatches `arogya:widgets:task-resolved` so list views
 * (DoctorQueueView, ManageVisitPage) can refresh action-pending state.
 */
export default function TaskResolutionWidget({ context, opts: _opts, onClose }) {
  const visit = context?.prefill?.visit || null;

  const handleSubmitted = (response) => {
    try {
      window.dispatchEvent(new CustomEvent('arogya:widgets:task-resolved', {
        detail: { visitId: context?.visitId, response },
      }));
    } catch (_e) { /* ignore */ }
    onClose?.();
  };

  if (!visit) {
    // Defensive: caller forgot to pass the visit row. Close so the
    // widget doesn't get stuck rendered as null.
    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      console.warn('[widgets] TaskResolutionWidget needs context.prefill.visit; closing.');
    }
    setTimeout(() => onClose?.(), 0);
    return null;
  }

  return (
    <ResolveActionPendingDialog
      visit={visit}
      onSubmitted={handleSubmitted}
      onCancel={() => onClose?.()}
    />
  );
}
